import styled from "@emotion/styled"

const Spacer = styled.span`
  display: inline-block;
  opacity: 0;
  width: ${(props) => props.width || "32px"};
`

export default Spacer
